module.exports = __webpack_public_path__ + "img/laba.738676b0.png";